import { render } from "./Maintenance.vue?vue&type=template&id=c3f168e8&scoped=true"
const script = {}

import "./Maintenance.vue?vue&type=style&index=0&id=c3f168e8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hori_taiki\\Desktop\\小野写真館\\環境構築\\point-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3f168e8"]])

export default __exports__